const routes = [
  {
    path: '/scheduleApproval', // 调度审批
    name: 'scheduleApproval',
    component: () => import('@src/modules/scheduleApproval/main'),
    redirect: '/scheduleApproval/index',
    meta: {
      requireAuth: true
    },
    children: [
      {
        path: 'index', //调度审批主界面
        name: 'index',
        component: () => import('@src/modules/scheduleApproval/pages/Index'),
        meta: {
          requireAuth: true,
          routerAlive: true
        }
      },
    ]
  },
]

export default routes
